import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Colors, Button, Intent, Spinner, H3 } from "@blueprintjs/core";
import { base } from "../fire";
import RandomString from "randomstring";
import FadeIn from 'react-fade-in';
import AdditionalInfos from '../components/Creer/AdditionalInfos'


import "../assets/components/Create.css";

import Context from '../components/Creer/Context'
import GeneralInfos from '../components/Creer/GeneralInfos'
import CreatePanelProtocol from "../components/Create/ProtocolPanel";
import ManualChoice from '../components/Create/SetupProtocol/ManualChoice'
import SequencePanel from "../components/Create/SequencesPanel";
import Auth from "../services/Auth";
import Session from "../services/Session";
import EmptyBox from "../components/Creer/EmptyBox";



import { storage } from "../fire";


class Creer extends React.Component {
    constructor(props) {
        super(props);
        /**
         * Firebase Note
         * Firebase doesn't store empty state variable so when creating the session
         * data content won't be store. It means that we need to check if these
         * variable are set when we are using it.
         */
        this.state = {
            id: null,
            CMContext: false,
            metadata: {
                author: null,
                status: "CLOSE",
                createdDate: null,
                shortUrl: "",
                rebrandLinkId: null,
                attributes: [],
                personalQuestions: [],
                chainedSession: "",
                language: "fr",
                shouldPromptUserName: false
            },
            data: {
                msCriterias: [],
                mcCriterias: [],
                feedbacks: [],
                interludes: [],
                conclusion: [],
                sequences: [],
                sequencesResources: [],
            }
        };
    }

    createSequenceCM = () => {
        let sequences = this.state.data.sequences
        if (sequences && sequences.length > 0) {
            this.setState({
                data: {
                    ...this.state.data, sequences: [...this.state.data.sequences, {
                        intro: '',
                        resources: [],
                        attributes: '',
                        sequencesContext: '',
                        attribute: [],
                        id: RandomString.generate(16)
                    }]
                }
            })
        } else {
            this.setState({
                data: {
                    ...this.state.data, sequences: [{
                        intro: '',
                        resources: [],
                        attributes: '',
                        sequencesContext: '',
                        attribute: [],
                        id: RandomString.generate(16)
                    }]
                }
            })
        }
    }


    handleChangeContextCM = (index, value) => {
        let sequences = this.state.data.sequences

        sequences[index - 1].sequenceContext = value
        this.setState({ data: { ...this.state.data, sequences: sequences } })
    }

    handleChangeSequencesResourcesCM = (index, sequencesResources) => {

        let sequences = this.state.data.sequences
        let sequence = this.state.data.sequences[index - 1]
        let newResources = sequencesResources

        if (sequence.resources && sequence.resources.length) {
            sequence.resources.forEach((resource) => {
                newResources = newResources.filter(item => !(item.id === resource.id));
            })
        }

        if (sequence.resources) {
            sequence.resources = [...sequence.resources, ...newResources]
        } else {
            sequence.resources = [...newResources]
        }

        sequences[index - 1] = sequence

        this.setState({ data: { ...this.state.data, sequences: sequences } })
    }

    handleReplacesResources = (sequenceIndex, resources) => {
        let sequences = this.state.data.sequences
        sequences[sequenceIndex - 1].resources = resources

        this.setState({ data: { ...this.state.data, sequences } })
    }

    handleChangeAttributeCM = (name, unit, ref, attr, sequenceIndex) => {

        let sequences = this.state.data.sequences
        let attributes = this.state.data.sequences[sequenceIndex - 1].attributes

        if (!attributes) {
            attributes = []
            attributes.push({ name: name, unit: unit, id: RandomString.generate(16), ref: ref })
        } else if (!attributes[attr]) {
            attributes.push({ name: name, unit: unit, id: RandomString.generate(16), ref: ref })
        } else {
            attributes[attr].name = name
            attributes[attr].unit = unit
            attributes[attr].id = RandomString.generate(16)
            attributes[attr].ref = ref
        }

        sequences[sequenceIndex - 1].attributes = attributes

        this.setState({ data: { ...this.state.data, sequences } })
    }

    handleChangeAttributeUnitValueCM = (value, attr, ress, sequenceIndex) => {
        let sequences = this.state.data.sequences
        let files = this.state.data.sequences[sequenceIndex - 1].resources

        if (!files[ress].attributes) {
            files[ress].attributes = []
            files[ress].attributes.push({ quantity: value })
        } else if (!files[ress].attributes[attr]) {
            files[ress].attributes.push({ quantity: value })
        } else {
            files[ress].attributes[attr] = { quantity: value }
        }

        sequences[sequenceIndex - 1].resources = files

        this.setState({ data: { ...this.state.data, sequences } })

    }

    handleDeleteAttributeCM = (attr, index, sequenceIndex) => {
        this.setState({ loadingDelete: true }, () => {

            let sequences = this.state.data.sequences
            let sequence = this.state.data.sequences[sequenceIndex - 1]

            sequence.attributes = sequence.attributes.filter(attribute => attribute !== attr)

            sequence.resources.forEach((resource) => {
                if (resource.attributes) {
                    resource.attributes.splice(index, 1)
                }
            })

            sequences[sequenceIndex - 1] = sequence

            this.setState({
                data: { ...this.state.data, sequences }
            }, () => {
                this.setState({ loadingDelete: false })
            })
        })
    }

    handleChangeIntroCM = (intro, sequenceIndex) => {
        let sequences = this.state.data.sequences
        let sequence = this.state.data.sequences[sequenceIndex - 1]

        sequence.intro = intro

        sequences[sequenceIndex - 1] = sequence

        this.setState({ data: { ...this.state.data, sequences } });
    }

    handleDeleteAttributeMC = (attr, index) => {
        this.setState({ loadingDelete: true }, () => {
            let attributes = this.state.metadata.attributes
            let mcCriterias = this.state.data.mcCriterias

            attributes = attributes.filter(attribute => attribute !== attr)

            mcCriterias.forEach((resource) => {
                if (resource.attributes) {
                    resource.attributes.splice(index, 1)
                }
            })

            this.setState({
                metadata: { ...this.state.metadata, attributes: attributes },
                data: { ...this.state.data, mcCriterias: mcCriterias }
            }, () => {
                this.setState({ loadingDelete: false })
            })
        })
    }

    displayContextCM = () => {
        this.setState({ CMContext: true })
    }

    handleChangeInput = (name, value) => {
        const { metadata } = this.state;
        this.setState({ metadata: { ...metadata, [name]: value } });
    };

    handleAddPersonalQuestion = (personalQuestion) => {
        if (!this.state.metadata.personalQuestions) {
            this.setState({ metadata: { ...this.state.metadata, personalQuestions: [personalQuestion] } })
        } else {
            let questions = this.state.metadata.personalQuestions
            this.setState({ metadata: { ...this.state.metadata, personalQuestions: [...questions, personalQuestion] } })
        }
    }

    handleRemovePersonalQuestion = (id) => {
        let questions = this.state.metadata.personalQuestions
        questions = questions.filter(question => question.id !== id)
        this.setState({ metadata: { ...this.state.metadata, personalQuestions: questions } })
    }

    emptyPersonalQuestions = () => {
        const { metadata } = this.state;
        this.setState({ metadata: { ...metadata, personalQuestions: [] } })
    }

    emptyFeedbacks = () => {
        const { data } = this.state;
        this.setState({ data: { ...data, feedbacks: [] } })
    }

    handleChangeCriteria_MS = msCriterias =>
        this.setState({ data: { ...this.state.data, msCriterias } });

    handleChangeCriteria_MC = mcCriterias =>
        this.setState({ data: { ...this.state.data, mcCriterias } });

    handleChangeCriteriaName = (id, name) => {
        let crits = this.state.data.mcCriterias
        crits[id].name = name
        this.setState({ data: { ...this.state.data, mcCriterias: crits } })
    }

    handleChangeFeedbacks = feedbacks =>
        this.setState({ data: { ...this.state.data, feedbacks } });

    handleChangeInterludes = interludes =>
        this.setState({ data: { ...this.state.data, interludes } });

    handleChangeSequences = sequences =>
        this.setState({ data: { ...this.state.data, sequences } });

    handleChangeSequencesResources = sequencesResources =>
        this.setState({ data: { ...this.state.data, sequencesResources } });

    handleChangeConclusion = conclusions =>
        this.setState({ data: { ...this.state.data, conclusions } });

    handleChangeChainedSession = chainedSession =>
        this.setState({ data: { ...this.state.data, chainedSession } });

    handleChangeAttribute = (name, unit, ref, attr) => {
        let attributes = []
        attributes = this.state.metadata.attributes
        if (!attributes) {
            attributes = []
            attributes.push({ name: name, unit: unit, id: RandomString.generate(16), ref: ref })
        } else if (!attributes[attr]) {
            attributes.push({ name: name, unit: unit, id: RandomString.generate(16), ref: ref })
        } else {
            attributes[attr].name = name
            attributes[attr].unit = unit
            attributes[attr].id = RandomString.generate(16)
            attributes[attr].ref = ref
        }
        this.setState({ metadata: { attributes: attributes } })
    }

    handleChangeAttributeUnitValue = (value, attr, ress, isMC) => {

        let files = this.state.data.sequencesResources
        let withFixedChannel = this.state.data.mcCriterias && this.state.data.mcCriterias.find(crit => crit.isFixed) 

        if (isMC) {
            files = this.state.data.mcCriterias
        }
        if (!files[ress].attributes) {
            files[ress].attributes = []
            files[ress].attributes.push({ quantity: value })
        } else if (!files[ress].attributes[attr]) {
            files[ress].attributes.push({ quantity: value })
        } else {
            files[withFixedChannel ? parseInt(ress) + 1 : ress].attributes[attr] = { quantity: value }
        }

        if (!isMC) {
            this.setState({ data: { sequencesResources: files } })
        } else {
            this.setState({ data: { mcCriterias: files } })
        }
    }

    handleDeleteAttribute = (attr, index) => {
        this.setState({ loadingDelete: true }, () => {
            let attributes = this.state.metadata.attributes
            let sequencesResources = this.state.data.sequencesResources

            attributes = attributes.filter(attribute => attribute !== attr)

            sequencesResources.forEach((resource) => {
                if (resource.attributes) {
                    resource.attributes.splice(index, 1)
                }
            })

            this.setState({
                metadata: { ...this.state.metadata, attributes: attributes },
                data: { ...this.state.data, sequencesResources: sequencesResources }
            }, () => {
                this.setState({ loadingDelete: false })
            })
        })
    }



    validateProtocol = () => {
        const { protocol } = this.state.metadata;
        return protocol != null && protocol.length > 0;
    };

    validateType = () => {
        const { type } = this.state.metadata;
        return type != null && type.length > 0;
    };

    validateName = () => {
        const { name } = this.state.metadata;
        return name != null && name.length > 0;
    };

    deleteAllInterludes = () => {
        if (this.state.data.interludes && this.state.data.interludes.length > 0) {
            this.state.data.interludes.forEach((interlude, i) => {
                let id = interlude.fileInternalName
                const storageRef = storage.ref(
                    `interludes/${Auth.getUserId()}/${this.state.sessionId}/${this.state.data.interludes.find(i => i.fileInternalName === id).fileInternalName
                    }`
                );
                storageRef.delete()
            })
            this.setState({ data: { ...this.state.data, interludes: [] } })
        }
    }

    deleteAllConclusions = () => {
        if (this.state.data.conclusions && this.state.data.conclusions.length > 0) {
            this.state.data.conclusions.forEach((conclusion, i) => {
                let id = conclusion.fileInternalName
                const storageRef = storage.ref(
                    `conclusions/${Auth.getUserId()}/${this.state.sessionId}/${this.state.data.conclusions.find(i => i.fileInternalName === id).fileInternalName
                    }`
                );
                storageRef.delete()
            })
            this.setState({ data: { ...this.state.data, conclusions: [] } })
        }
    }

    deleteChainedSession = () => {
      this.setState({ metadata: { ...this.state.data, chainedSession: "" } });
    };


    render() {
        // const tabProtocolEnabled =
        //     // this.validateType() &&
        //     this.validateProtocol() &&
        //     this.validateName();
        // const tabSequencesEnabled = this.validateName() && this.validateProtocol();
        const { metadata } = this.state;
        const { data } = this.state;
        const {
            msCriterias = [],
            mcCriterias = [],
            feedbacks = [],
            sequences = [],
            sequencesResources = [],
            interludes = [],
            conclusions = [],
            chainedSession = "",
        } = data;

        return (
            <div className="main animated fadeIn">
                {/* GENERAL INFOS */}
                <H3 className='text-center margin-bottom-medium'>Configure your session</H3>
                <FadeIn>
                    <GeneralInfos
                        {...metadata}
                        resources={sequencesResources}
                        msCriterias={this.state.data.msCriterias}
                        mcCriterias={this.state.data.mcCriterias}
                        onInputChange={this.handleChangeInput}
                    />
                </FadeIn>

                {/* IMAGES */}
                {metadata.protocol &&
                    <FadeIn>
                        <H3 className='text-center margin-bottom-medium'>
                            {(metadata.protocol === 'PC') && 'Your Images*'}
                            {(metadata.protocol === 'MS') && 'Your Images*'}
                            {(metadata.protocol === 'MC') && 'Your Channels*'}
                        </H3>
                        {(metadata.protocol === 'CM') &&
                            <ManualChoice
                                createSequence={this.createSequenceCM}
                                changeContext={this.handleChangeContextCM}
                                sequences={sequences}
                                changeResources={this.handleChangeSequencesResourcesCM}
                                handleChangeSequencesResourcesCM={this.handleChangeSequencesResourcesCM}
                                attributes={this.state.metadata.attributes}
                                handleChangeAttribute={this.handleChangeAttributeCM}
                                handleChangeAttributeUnitValue={this.handleChangeAttributeUnitValueCM}
                                handleDeleteAttribute={this.handleDeleteAttributeCM}
                                loadingDelete={this.state.loadingDelete}
                                handleReplacesResources={this.handleReplacesResources}
                                sessionId={this.state.id}
                                onChangeInterludes={this.handleChangeIntroCM}
                                displayContextCM={this.displayContextCM}
                            />
                        }
                        {(metadata.protocol === 'MC') &&
                            <FadeIn>
                                {this.state.loadingDelete
                                    ?
                                    <div style={{ marginTop: "20px" }}>
                                        <Spinner size={500} />
                                    </div>
                                    :
                                    <CreatePanelProtocol
                                        sessionId={this.state.id}
                                        protocol={this.state.metadata.protocol}
                                        mcCriterias={mcCriterias}
                                        msCriterias={msCriterias}
                                        onChangeCriteria_MC={this.handleChangeCriteria_MC}
                                        onChangeCriteria_MS={this.handleChangeCriteria_MS}
                                        onChangeCriteriaName={this.handleChangeCriteriaName}
                                        attributes={this.state.metadata.attributes}
                                        handleChangeAttribute={this.handleChangeAttribute}
                                        handleChangeAttributeUnitValue={this.handleChangeAttributeUnitValue}
                                        handleDeleteAttribute={this.handleDeleteAttributeMC}
                                    />}
                            </FadeIn>
                        }
                        {(metadata.protocol === 'PC' || metadata.protocol === 'MS') &&
                            <FadeIn>
                                {this.state.loadingDelete
                                    ?
                                    <div style={{ marginTop: "20px" }}>
                                        <Spinner size={500} />
                                    </div>
                                    :
                                    <SequencePanel
                                        sessionId={this.state.id}
                                        protocol={metadata.protocol}
                                        mcCriterias={mcCriterias} // Only for MC to set channels uses by sequences
                                        sequences={sequences}
                                        attributes={metadata.attributes}
                                        resources={sequencesResources}
                                        onChangeSequences={this.handleChangeSequences}
                                        onChangeSequencesResources={this.handleChangeSequencesResources}
                                        onchangeMeta={this.handleChangeInput}
                                        handleChangeAttribute={this.handleChangeAttribute}
                                        handleChangeAttributeUnitValue={this.handleChangeAttributeUnitValue}
                                        handleDeleteAttribute={this.handleDeleteAttribute}
                                    />}
                            </FadeIn>
                        }
                        {/* CONFIGURE PROTOCOL */}
                        {(data.sequencesResources && data.sequencesResources.length > 1) &&
                            <Fragment>
                                {(metadata.protocol === 'MS' && data.sequences) &&
                                    <FadeIn>
                                        {this.state.loadingDelete
                                            ?
                                            <div style={{ marginTop: "20px" }}>
                                                <Spinner size={500} />
                                            </div>
                                            :
                                            <CreatePanelProtocol
                                                sessionId={this.state.id}
                                                protocol={this.state.metadata.protocol}
                                                mcCriterias={mcCriterias}
                                                msCriterias={msCriterias}
                                                onChangeCriteria_MC={this.handleChangeCriteria_MC}
                                                onChangeCriteria_MS={this.handleChangeCriteria_MS}
                                                onChangeCriteriaName={this.handleChangeCriteriaName}
                                                attributes={this.state.metadata.attributes}
                                                handleChangeAttribute={this.handleChangeAttribute}
                                                handleChangeAttributeUnitValue={this.handleChangeAttributeUnitValue}
                                                handleDeleteAttribute={this.handleDeleteAttributeMC}
                                            />
                                        }
                                    </FadeIn>
                                }
                            </Fragment>
                        }
                        {(metadata.protocol === 'MC' && mcCriterias && mcCriterias.length) ?
                            <FadeIn className='margin-top-large'>
                                {this.state.loadingDelete
                                    ?
                                    <div style={{ marginTop: "20px" }}>
                                        <Spinner size={500} />
                                    </div>
                                    :
                                    <SequencePanel
                                        sessionId={this.state.id}
                                        protocol={metadata.protocol}
                                        mcCriterias={mcCriterias} // Only for MC to set channels uses by sequences
                                        sequences={sequences}
                                        attributes={metadata.attributes}
                                        resources={sequencesResources}
                                        onChangeSequences={this.handleChangeSequences}
                                        onChangeSequencesResources={this.handleChangeSequencesResources}
                                        onchangeMeta={this.handleChangeInput}
                                        handleChangeAttribute={this.handleChangeAttribute}
                                        handleChangeAttributeUnitValue={this.handleChangeAttributeUnitValue}
                                        handleDeleteAttribute={this.handleDeleteAttribute}
                                    />
                                }
                            </FadeIn>
                            :
                            null
                        }
                        {/* ADDITIONAL INFORMATIONS */}
                        {(sequences && sequences.length > 0 && ((metadata.protocol === 'CM' && (this.state.CMContext || (this.state.data.sequences && this.state.data.sequences.length === 6))) || metadata.protocol !== 'CM')) &&
                            <Fragment>
                                <FadeIn>
                                    <H3 className='text-center margin-bottom-medium margin-top-medium'>General {metadata.protocol === 'PC' ? 'question ' : 'context '}of the session</H3>
                                    <Context
                                        context={this.state.metadata.context}
                                        onInputChange={this.handleChangeInput}
                                        protocol={metadata.protocol}
                                    />
                                </FadeIn>
                                {((metadata.protocol !== 'MS') && metadata.context && metadata.context !== '') &&
                                    <AdditionalInfos
                                        protocol={metadata.protocol}
                                        feedbacks={feedbacks}
                                        handleChangeFeedbacks={this.handleChangeFeedbacks}
                                        handleChangeInput={this.handleChangeInput}
                                        interludes={interludes}
                                        sessionId={this.state.id}
                                        handleChangeInterludes={this.handleChangeInterludes}
                                        conclusions={conclusions}
                                        handleChangeConclusion={this.handleChangeConclusion}
                                        personalQuestions={this.state.metadata.personalQuestions}
                                        addPersonalQuestion={this.handleAddPersonalQuestion}
                                        handleRemovePersonalQuestion={this.handleRemovePersonalQuestion}
                                        emptyPersonalQuestions={this.emptyPersonalQuestions}
                                        emptyFeedbacks={this.emptyFeedbacks}
                                        type={this.state.metadata.type}
                                        deleteAllInterludes={this.deleteAllInterludes}
                                        deleteAllConclusions={this.deleteAllConclusions}
                                        chainedSession={chainedSession}
                                        deleteChainedSession={this.deleteChainedSession}
                                    />
                                }
                                {((metadata.protocol === 'MS') && data.msCriterias && metadata.context && (metadata.context !== '')) &&
                                    <AdditionalInfos
                                        protocol={metadata.protocol}
                                        feedbacks={feedbacks}
                                        handleChangeFeedbacks={this.handleChangeFeedbacks}
                                        handleChangeInput={this.handleChangeInput}
                                        interludes={interludes}
                                        sessionId={this.state.id}
                                        handleChangeInterludes={this.handleChangeInterludes}
                                        conclusions={conclusions}
                                        handleChangeConclusion={this.handleChangeConclusion}
                                        personalQuestions={this.state.metadata.personalQuestions}
                                        addPersonalQuestion={this.handleAddPersonalQuestion}
                                        handleRemovePersonalQuestion={this.handleRemovePersonalQuestion}
                                        emptyPersonalQuestions={this.emptyPersonalQuestions}
                                        emptyFeedbacks={this.emptyFeedbacks}
                                        type={this.state.metadata.type}
                                        deleteAllInterludes={this.deleteAllInterludes}
                                        deleteAllConclusions={this.deleteAllConclusions}
                                        chainedSession={chainedSession}
                                        deleteChainedSession={this.deleteChainedSession}
                                    />
                                }
                            </Fragment>
                        }

                    </FadeIn>
                }
                <EmptyBox size='smallContainer' />
                <div className="text-right" style={{ marginTop: "30px" }}>
                    <Button
                        text="Your session is automatically saved"
                        rightIcon="tick"
                        style={{ color: Colors.GREEN3, marginRight: "5px" }}
                        intent={Intent.NONE}
                        disabled={true}
                    />
                    <Link to="/">
                        <Button
                            text="Finish"
                            rightIcon="confirm"
                            intent={Intent.SUCCESS}
                        />
                    </Link>
                </div>
                <br /><br />
            </div>
        );
    }

    componentWillMount() {
        Session.createSession(this.state)
            .then(({ endpoint }) => {
                this.syncIdRef = base.syncState(`${endpoint}/id`, {
                    context: this,
                    state: "id"
                });
                this.syncMetadataRef = base.syncState(`${endpoint}/metadata`, {
                    context: this,
                    state: "metadata"
                });
                this.syncDataRef = base.syncState(`${endpoint}/data`, {
                    context: this,
                    state: "data"
                });
                this.setState({
                    metadata: {
                        ...this.state.metadata,
                        author: Auth.getUserId(),
                        createdDate: Date.now()
                    }
                });
            })
            .catch(e => console.error(e));
    }

    componentWillUnmount() {
        if (this.syncIdRef) base.removeBinding(this.syncIdRef);
        if (this.syncMetadataRef) base.removeBinding(this.syncMetadataRef);
        if (this.syncDataRef) base.removeBinding(this.syncDataRef);
        if (this.postSessionRef) base.removeBinding(this.postSessionRef);
    }
}

export default Creer;
